var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 50,
    viewBox: "0 0 186 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple",
    transform: "translate(-274.958 -623)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 186,
    height: 50,
    rx: 6,
    transform: "translate(274.958 623)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Available_on_the",
    "data-name": "Available on the",
    transform: "translate(352.958 641)",
    fill: "#dfdfdf",
    fontSize: 9,
    fontFamily: "Inter-Regular, Inter"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available on the")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(352.958 661)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Inter-Medium, Inter",
    fontWeight: 500,
    letterSpacing: "0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store")), /*#__PURE__*/React.createElement("g", {
    id: "apple-2",
    "data-name": "apple",
    transform: "translate(316.959 634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M259.47-511.849a6.76,6.76,0,0,0-4.384,4.777,6.252,6.252,0,0,0-.087,1.019v.614l.539-.035a5.612,5.612,0,0,0,4.847-4.47,8.9,8.9,0,0,0,.232-1.755v-.3l-.33.006A3.481,3.481,0,0,0,259.47-511.849Z",
    transform: "translate(-244.406 512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M61.553-394.144a7.568,7.568,0,0,0-2.255.58c-.4.15-.886.339-1.075.408-.493.183-.7.167-1.573-.145-2-.715-2.334-.8-3.178-.8a6.847,6.847,0,0,0-3.8,1.295,7.662,7.662,0,0,0-3.053,5.072,9.009,9.009,0,0,0-.121,2.015,9.442,9.442,0,0,0,.121,2.042,21.758,21.758,0,0,0,1.149,4.084c1.374,3.562,3.352,6.034,5.235,6.528a5.089,5.089,0,0,0,1.888-.022c.262-.059.85-.242,1.311-.408a5.3,5.3,0,0,1,1.888-.51,4.9,4.9,0,0,1,1.888.5,4.462,4.462,0,0,0,2.072.484,2.565,2.565,0,0,0,1.023-.14,4.884,4.884,0,0,0,2.046-1.408,12.593,12.593,0,0,0,2.486-3.707c.734-1.521.965-2.2.876-2.574-.052-.226-.33-.5-.8-.79a4.661,4.661,0,0,1-2.465-3.981,4.56,4.56,0,0,1,1.316-3.578,15.163,15.163,0,0,1,1.647-1.386,7.367,7.367,0,0,0-.761-1.134A6.683,6.683,0,0,0,61.553-394.144Z",
    transform: "translate(-46.5 400.987)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d6bf0304961079d7343cf5533931ed77.svg";
export { ForwardRef as ReactComponent };